/** Thin fetch client for the same-origin API. Errors carry the machine code from problem+json. */
export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    public details?: unknown,
  ) {
    super(code)
  }
}

type Listener = () => void
const stepUpListeners = new Set<Listener>()
export const onStepUpRequired = (l: Listener) => {
  stepUpListeners.add(l)
  return () => {
    stepUpListeners.delete(l)
  }
}

export async function api<T = unknown>(
  path: string,
  init: { method?: string; body?: unknown } = {},
): Promise<T> {
  const res = await fetch(path, {
    method: init.method ?? (init.body === undefined ? 'GET' : 'POST'),
    headers: init.body === undefined ? {} : { 'content-type': 'application/json' },
    body: init.body === undefined ? undefined : JSON.stringify(init.body),
    credentials: 'same-origin',
  })
  if (res.status === 204) return undefined as T
  const text = await res.text()
  const data = text ? JSON.parse(text) : null
  if (!res.ok) {
    const err = new ApiError(res.status, data?.code ?? 'http_error', data?.details)
    if (err.code === 'step_up_required') for (const l of stepUpListeners) l()
    if (err.code === 'mfa_required' && !location.pathname.startsWith('/mfa')) {
      location.href = `/mfa?next=${encodeURIComponent(location.pathname + location.search)}`
    }
    throw err
  }
  return data as T
}

export const wsPath = (ws: string, p: string) => `/api/ws/${ws}${p}`
